import { Card } from '@yleisradio/areena-types';
import { findLabel, getCardKey } from 'utils/card';

type BroadcastStatus = 'expired' | 'current' | 'upcoming';

export const determineBroadcastStatus = (
  card: Card,
  time: number
): BroadcastStatus => {
  const startDateLabel = findLabel(card.labels, 'broadcastStartDate')?.raw;
  const endDateLabel = findLabel(card.labels, 'broadcastEndDate')?.raw;

  if (!startDateLabel) throw new Error('Missing broadcastStartDate label');
  if (!endDateLabel) throw new Error('Missing broadcastEndDate label');

  const start = Date.parse(startDateLabel);
  const end = Date.parse(endDateLabel);

  if (isNaN(start)) throw new Error('Invalid broadcastStartDate label');
  if (isNaN(end)) throw new Error('Invalid broadcastEndDate label');

  if (time > end) return 'expired';
  if (time < start) return 'upcoming';
  return 'current';
};

export interface ScheduledProgram extends Card {
  key: string;
}

export function createSchedule(
  schedule: Card[],
  time: number,
  listKey: string
): Record<BroadcastStatus, ScheduledProgram[]> {
  const cardsWithKeys = schedule.map<ScheduledProgram>((card, i) => ({
    ...card,
    key: getCardKey(card, i, listKey),
  }));

  const getByStatus = (status: BroadcastStatus) =>
    cardsWithKeys.filter(
      (card) => determineBroadcastStatus(card, time) === status
    );

  return {
    expired: getByStatus('expired'),
    current: getByStatus('current'),
    upcoming: getByStatus('upcoming'),
  };
}
